import { render, staticRenderFns } from "./px-switch.vue?vue&type=template&id=09844da9&scoped=true&"
import script from "./px-switch.vue?vue&type=script&lang=ts&"
export * from "./px-switch.vue?vue&type=script&lang=ts&"
import style0 from "./px-switch.vue?vue&type=style&index=0&id=09844da9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09844da9",
  null
  
)

export default component.exports